import { render, staticRenderFns } from "./QuotationListView.vue?vue&type=template&id=c99f7022"
import script from "./QuotationListView.vue?vue&type=script&lang=js"
export * from "./QuotationListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports